(ns client-portal.client.smart-ordering.sessions.views
  (:require [clojure.string :as s]
            [client-portal.client.layout :as l]
            [client-portal.client.smart-ordering.sessions.data :as so.sessions.d]
            [client-portal.client.smart-ordering.sessions.drawer.views]
            [client-portal.client.smart-ordering.filters.views :as so.filters]
            [client-portal.client.smart-ordering.sessions.utterances.views :as so.utterances]
            [client-portal.client.vi.components.tag :as tag]
            [client-portal.client.voice-insights.empty-state :as empty-state]
            [client-portal.client.voice-insights.sessions.data :as vi.sessions.d]
            [client-portal.client.voice-insights.sessions.list.views :as vi.list]
            [client-portal.client.voice-insights.tag-data :as tag.d]
            [client-portal.client.voice-insights.sessions.utterances.views :as vi.utterances]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.components.components :as c]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.time :as t]
            [shared.core.util :as util]))

(defn sessions-header []
  (let [container-id "so-sessions-header-container"
        count- (re/subscribe [:smart-ordering/sessions-count-])
        admin?- (re/subscribe [:account/admin-role?-])
        view-mode- (re/subscribe [:smart-ordering/view-mode-])
        vs- (re/subscribe [:core/viewport-size])
        applied-filters- (re/subscribe [:so-filters/applied-filters-])
        set-header-height #(when-let [h (some-> (js/document.getElementById container-id)
                                                (.getBoundingClientRect)
                                                (.-height))]
                             (re/dispatch [:smart-ordering/set-header-height h]))]
    (re/create-class
      {:component-did-mount set-header-height
       :component-did-update set-header-height
       :reagent-render
       (fn []
         @vs- @applied-filters-
         [:div {:id container-id
                :style {:background-color (style/alc-color "Background/card_hex")
                        :display :flex
                        :flex-direction :column
                        :gap 16
                        :padding "12px 16px 16px"
                        :position :sticky
                        :top 0
                        :z-index (inc (style/z :medium))}}
          [:span {:style {:color (style/alc-color "Text/primary_header")
                          :font-size 24
                          :line-height 1.33}}
           "Sessions"
           (when-not (util/loading? @count-)
             [:span {:style {:color (style/alc-color "Text/primary")
                             :margin-left 8}}
              (str "(" (some-> @count- (util/readable-number)) ")")])]
          [:div {:style {:display :flex
                         :align-items :flex-end
                         :justify-content :space-between}}
           [alc/up-toggle-group
            {:type "single"
             :value @view-mode-
             :on-value-change (fn [v]
                                (when (not-empty v)
                                  (re/dispatch [:voice-insights/scroll-to-top])
                                  (re/dispatch [:smart-ordering/select-view-mode v])))
             :items (mapv (fn [{:keys [mode icon-type icon-content label]}]
                            {:value mode
                             :content [:div {:style {:display :flex
                                                     :align-items :center
                                                     :gap 6}}
                                       (or icon-content
                                           [c/material-icon {:icon-type icon-type
                                                             :style {:font-size 16}}])
                                       [:span label]]})
                          [{:mode "sessions"
                            :icon-type :forum
                            :label "Sessions"}
                           {:mode "utterances"
                            :icon-content [vi.utterances/utterance-icon {:color "currentColor"}]
                            :label "Utterances"}])}]
           [:div {:style {:display :flex
                          :align-items :center
                          :gap 8}}
            [so.filters/filter-button {:config so.sessions.d/filters-config}]
            (when @admin?-
              (let [search (fn [e]
                             (when-let [el (js/document.getElementById "so-convo-id-search-input")]
                               (let [v (or (some-> e (.-clipboardData) (.getData "text/plain"))
                                           (.-value el))]
                                 (when (not-empty v)
                                   (re/dispatch [:smart-ordering/toggle-session-panel {:conversation-id (s/trim v)
                                                                                       :open? true}]))
                                 (set! (.-value el) "")
                                 (.blur el))))]
                [alc/up-input {:id :so-convo-id-search-input
                               :class-name "w-60"
                               :placeholder "Search By Convo ID"
                               :on-key-down #(when (util/enter-key-event? %)
                                               (search %))
                               :on-paste search}]))]]
          [so.filters/applied-filter-pills {:config so.sessions.d/filters-config}]])})))

(defn sessions-list []
  (let [sessions- (re/subscribe [:smart-ordering/sessions-flattened-])
        location-id->label- (re/subscribe [:locations/location-id->label-by-current-concept-id-])
        loading?- (re/subscribe [:smart-ordering/sessions-list-loading?-])
        has-more?- (re/subscribe [:smart-ordering/sessions-has-more?-])
        next-page-loading?- (re/subscribe [:smart-ordering/sessions-next-page-loading?-])
        next-page- (re/subscribe [:smart-ordering/sessions-next-page-])
        admin?- (re/subscribe [:account/admin-role?-])
        selected- (re/subscribe [:smart-ordering/selected-session-])
        header-height- (re/subscribe [:smart-ordering/header-height-])]
    (fn []
      (let [admin? @admin?-
            show-locations? (> (count (util/when-not-loading @location-id->label-)) 1)
            selected-id (:conversation-id @selected-)
            selected-style {:background-color (style/alc-color "Background/active_secondary")}]
        [alc/table {:no-data-text "No sessions to display"
                    :loading? @loading?-
                    :loading-more? @next-page-loading?-
                    :scroll-container-id l/core-scroll-content-id
                    :bottom-px-buffer 200
                    :on-bottom-buffer (when @has-more?-
                                        #(re/dispatch [:smart-ordering/load-sessions [nil {:page @next-page-}]]))
                    :has-more-rows? true
                    :sticky-headers? true
                    :expanded-form-path so.sessions.d/table-columns-path
                    :header-top @header-height-
                    :row-style {:height :auto
                                :align-items :flex-start}
                    :flex-vals (filterv identity
                                        [(when admin? "0 0 100px")
                                         "0 0 120px"
                                         (when show-locations? "0 0 180px")
                                         "0 0 70px"
                                         "0 0 78px"
                                         "0 0 90px"
                                         1])
                    :headers (filterv identity
                                      [(when admin? "Conversation ID")
                                       "Timestamp"
                                       (when show-locations? "Location")
                                       "Duration"
                                       {:column-id "outcome"
                                        :label "Outcome"
                                        :expandable? true
                                        :expanded-flex-val "0 0 135px"}
                                       "Total"
                                       {:label "Tags"
                                        :style {:padding "0px 0px 0px 5px"}}])
                    :rows (map-indexed
                            (fn [idx {:keys [conversation-id dataset-id conversation-ts location-id duration conversation-tags utterance-tags]}]
                              (let [outcome (so.sessions.d/tag-by-name conversation-tags "ai-outcome")
                                    utterance-pills (->> (tag.d/remove-internal-tags (filterv :name utterance-tags))
                                                         (remove #(so.sessions.d/sessions-table-hidden-utterance-tag-names (:name %)))
                                                         (group-by (juxt :name :value))
                                                         (mapv (fn [[_ tags]]
                                                                 [tag/utterance-tag-pill (assoc (first tags)
                                                                                           :count (count tags)
                                                                                           :children (mapcat :children tags)
                                                                                           :show-description? true)])))
                                    conversation-pills (->> (tag.d/remove-internal-tags (filterv :name conversation-tags))
                                                            (remove #(so.sessions.d/sessions-table-hidden-conversation-tag-names (:name %)))
                                                            (sort-by tag/tag->display-name)
                                                            (mapv #(vector tag/conversation-tag-pill (assoc % :show-description? true))))]
                                {:cells (filterv identity
                                                 [(when admin?
                                                    {:label conversation-id
                                                     :copyable? true
                                                     :style {:color (style/alc-color "Text/secondary")
                                                             :white-space :nowrap}})
                                                  {:label [:span {:style {:color (style/alc-color "Text/secondary")}}
                                                           conversation-ts]}
                                                  (when show-locations?
                                                    {:label (get @location-id->label- (util/parse-int location-id))})
                                                  {:label (some-> duration (js/Math.round) (t/seconds->format))}
                                                  {:label [vi.list/outcome-icon {:tag outcome}]
                                                   :expanded-content [vi.list/outcome-label {:tag outcome}]}
                                                  {:label (or (so.sessions.d/order-price conversation-tags "internal/validated-total") "-")}
                                                  {:label (into [:div {:style {:display :flex
                                                                               :flex-wrap :wrap
                                                                               :gap 8}}]
                                                                (concat utterance-pills conversation-pills))
                                                   :style {:flex-wrap :wrap
                                                           :padding "0 12px"}}])
                                 :on-click #(re/dispatch [:smart-ordering/toggle-session-panel {:conversation-id conversation-id
                                                                                                :dataset-id dataset-id
                                                                                                :conversation-ts conversation-ts
                                                                                                :convo-idx idx}])
                                 :hover-style (when (= selected-id conversation-id) selected-style)
                                 :style (when (= selected-id conversation-id) selected-style)}))
                            @sessions-)}]))))

(defn root [_]
  (let [cur-route- (re/subscribe [:router/current-route-])
        sessions- (re/subscribe [:smart-ordering/sessions-flattened-])
        loading?- (re/subscribe [:smart-ordering/sessions-list-loading?-])
        locations- (re/subscribe [:locations/by-current-concept-id-])
        selected- (re/subscribe [:smart-ordering/selected-session-])
        active-panel- (re/subscribe [:layout/active-panel-right-])
        view-mode- (re/subscribe [:smart-ordering/view-mode-])
        utterances-list- (re/subscribe [:smart-ordering/utterances-list-])
        open-session-from-conv (fn [this]
                                 (when-let [conv (some-> (:conv (re/props this))
                                                         (vi.sessions.d/conv-qp->conversation)
                                                         (util/->kebab-case-keywords))]
                                   (when-not (and (= (first @active-panel-) so.sessions.d/panel-key)
                                                  (= (:conversation-id conv) (:conversation-id @selected-)))
                                     (re/dispatch [:smart-ordering/toggle-session-panel (assoc conv :open? true)]))))]
    (re/create-class
      {:component-did-mount (fn [this]
                              (re/dispatch [:smart-ordering/sessions-initialize])
                              (open-session-from-conv this))
       :component-did-update open-session-from-conv
       :component-will-unmount #(re/dispatch [:layout/hide-panel-right])
       :reagent-render
       (fn [args]
         @utterances-list-
         (let [view-mode @view-mode-
               loading? (or @loading?- (util/loading? @locations-))]
           [l/logged-in-with-header-nav-smart-ordering
            (merge args {:concept-dropdown? true
                         :location-dropdown? true
                         :concept-dropdown-config
                         {:extra-on-change
                          (fn [value]
                            (let [cid (when (not (s/blank? value))
                                        (util/parse-int value))
                                  [route-name route-params route-query] @cur-route-]
                              (re/dispatch [:locations/clear-selected])
                              (re/dispatch [:smart-ordering/toggle-session-panel {:open? false}])
                              (re/dispatch [:router/go [route-name
                                                        route-params
                                                        (cond-> (dissoc (or route-query {}) :lid :conv)
                                                                cid (assoc :cid cid)
                                                                (not cid) (dissoc :cid))]])))}})
            [:div {:style {:display :flex
                           :flex-direction :column
                           :width "100%"
                           :min-height "100%"}}
             [sessions-header]
             [:div {:style {:flex 1
                            :display :flex
                            :flex-direction :column
                            :padding "0 16px 12px"}}
              (cond
                (and (= view-mode "sessions") loading?) [empty-state/loading-sessions-card]
                (and (empty? @sessions-) (not loading?)) [empty-state/no-sessions-card]
                (= view-mode "utterances") [so.utterances/utterances-view]
                :else [sessions-list])]]]))})))
